import Cookies from 'js-cookie';
import { observable, runInAction } from 'mobx';
import { getCustomerPathSegment } from '../util/SegmentUtil';
import ShopAPI from '../util/ShopApiUtil';
import LanguageStore from './LanguageStore';
import RootStore from './RootStore';
import SegmentStore, { SEGMENT_ARI, SEGMENT_ERA } from './SegmentStore';
import SsoStore from './SsoStore';

const SHOPPING_CART_ICON_COOKIE_NAME = 'shoppingCartIcon';

export interface ProductToCartData {
  productCode: string;
  url: string;
  serviceProduct?: boolean;
}

class ShoppingCartStore {
  @observable accessor cartItemsNumber: number = 0;
  private languageStore: LanguageStore;
  private ssoStore: SsoStore;
  private segmentStore: SegmentStore;

  constructor(rootStore: RootStore) {
    this.languageStore = rootStore.languageStore;
    this.ssoStore = rootStore.ssoStore;
    this.segmentStore = rootStore.segmentStore;
    this.updateCartItemsNumber();
  }

  public updateCartItemsNumber = () => {
    runInAction(() => {
      this.cartItemsNumber = this.getShoppingCartIconCookieValue();
    });
  };

  private resolveClientType = (): 'era' | 'ari' => {
    if (this.ssoStore.auth?.customer?.type) {
      return this.ssoStore.auth.customer.type === 'B2B' ? SEGMENT_ARI : SEGMENT_ERA;
    }
    return getCustomerPathSegment(this.segmentStore.currentSegment);
  };

  private getShoppingCartIconCookieValue() {
    const cookie = Cookies.get(SHOPPING_CART_ICON_COOKIE_NAME);
    if (cookie) {
      const parsedCookie: number = parseInt(cookie, 10);
      if (!Number.isNaN(parsedCookie)) {
        return parsedCookie;
      }
    }
    return 0;
  }

  public addProductToCart = async ({ productCode, url, serviceProduct }: ProductToCartData) => {
    const isAllowedResponse = await ShopAPI.get(`/availability${serviceProduct ? '/service' : ''}/is-allowed-for-sale`, {
      params: {
        productCode,
        clientType: this.resolveClientType(),
      },
    });
    if (isAllowedResponse.data) {
      const result = await ShopAPI.post('/cart/add', {
        productCode,
        url,
        serviceProduct,
        lang: this.languageStore.currentLanguage,
        client: this.resolveClientType(),
      });
      this.updateCartItemsNumber();
      return result;
    }
  };
}

export default ShoppingCartStore;
